import React, { useImperativeHandle } from 'react';
import './index.less';

const FeedBackLayout = React.forwardRef((props, ref) => {
  useImperativeHandle(ref, () => {
    return {
      show: (show) => {},
    };
  });

  return null;
});
export default FeedBackLayout;
